// BookingsTable.js
import React from "react";
import { useTranslation } from "react-i18next";

const BookingsTable = ({ bookings }) => {
  const { t } = useTranslation("dash");

  const getLangFromLocalStorage = () =>
    localStorage.getItem("language") || "en";

  const formatDateTime = (dateString) => {
    const locale = getLangFromLocalStorage();
    // default options will include date and time
    const formatted = new Date(dateString).toLocaleString(locale, {
      hour12: true,
    });
    if(locale === 'en'){
      return formatted;
    }
    return formatted.replace(/AM/g, "ص").replace(/PM/g, "م");
  };

  if (!bookings || bookings.length === 0) {
    return (
      <div className="dashboard-table">
        <h2 className="dashboard-subtitle">{t("subtitle")}</h2>
        <table>
          <thead>
            <tr>
              <th>{t("tableHeaders.customer")}</th>
              <th>{t("tableHeaders.company")}</th>
              <th>{t("tableHeaders.from")}</th>
              <th>{t("tableHeaders.to")}</th>
              <th>{t("tableHeaders.cost")}</th>
              <th>{t("tableHeaders.action")}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="6" style={{ textAlign: "center" }}>
                {t("noData")}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="dashboard-table">
      <h2 className="dashboard-subtitle">{t("subtitle")}</h2>
      <table>
        <thead>
          <tr>
            <th>{t("tableHeaders.customer")}</th>
            <th>{t("tableHeaders.company")}</th>
            <th>{t("tableHeaders.from")}</th>
            <th>{t("tableHeaders.to")}</th>
            <th>{t("tableHeaders.cost")}</th>
            <th>{t("tableHeaders.action")}</th>
          </tr>
        </thead>
        <tbody>
          {bookings.map((booking) => (
            <tr key={booking.id}>
              <td>{booking.user_name}</td>
              <td>{booking.company}</td>
              <td>{formatDateTime(booking.start)}</td>
              <td>{formatDateTime(booking.end)}</td>
              <td>{booking.cost || "-"}</td>
              <td>
                <img src="/more-circle2.svg" alt={t("tableHeaders.action")} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BookingsTable;
